import React from "react";
import { Component } from "react";
import TextMask from "react-text-mask";
import { fullWidthToHalfWidth } from "checkout/ts/utils/numbers";
import { isChrome, isWindows } from "common/utils/browser";
import Payment from "payment";
import { CardBrand } from "univapay-node";

import { cardBrandAPIName } from "../../../utils/cards";

const CARD_NUMBER_BASE_MASK: (string | RegExp)[] = [/[1-9１-９]/, /[0-9０-９]/, /[0-9０-９]/, /[0-9０-９]/, " "];

const CARD_NUMBER_GENERIC_MASK = CARD_NUMBER_BASE_MASK.concat([
    /[0-9０-９]/,
    /[0-9０-９]/,
    /[0-9０-９]/,
    /[0-9０-９]/,
    " ",
    /[0-9０-９]/,
    /[0-9０-９]/,
    /[0-9０-９]/,
    /[0-9０-９]/,
    " ",
    /[0-9０-９]/,
    /[0-9０-９]/,
    /[0-9０-９]/,
    /[0-9０-９]/,
]);

const CARD_NUMBER_OTHER_MASK = CARD_NUMBER_BASE_MASK.concat([
    /[0-9０-９]/,
    /[0-9０-９]/,
    /[0-9０-９]/,
    /[0-9０-９]/,
    /[0-9０-９]/,
    /[0-9０-９]/,
    " ",
]);

const CARD_NUMBER_AMEX_MASK = CARD_NUMBER_OTHER_MASK.concat([
    /[0-9０-９]/,
    /[0-9０-９]/,
    /[0-9０-９]/,
    /[0-9０-９]/,
    /[0-9０-９]/,
]);

const CARD_NUMBER_DINERS_MASK = CARD_NUMBER_OTHER_MASK.concat([/[0-9０-９]/, /[0-9０-９]/, /[0-9０-９]/, /[0-9０-９]/]);

const masks = {
    [CardBrand.AMEX]: CARD_NUMBER_AMEX_MASK,
    [CardBrand.DINERS]: CARD_NUMBER_DINERS_MASK,
};

export type CardNumberInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange"> & {
    onChange?: (value: string) => void;
};

export class CardNumberInput extends Component<CardNumberInputProps, any> {
    handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value: eventValue } = event.target as HTMLInputElement;
        this.props.onChange?.(fullWidthToHalfWidth(eventValue));
    };

    render() {
        const { value = "", placeholder, ...props } = this.props;
        const brand = cardBrandAPIName(Payment.fns.cardType(String(value))) || "unknown";
        const mask = masks[brand] || CARD_NUMBER_GENERIC_MASK;

        const skipAutoFormatting = isChrome() && isWindows();
        const disableFormattingOnCapture = (event) => {
            event.stopPropagation();
            event.preventDefault();
            return false;
        };

        return (
            <TextMask
                {...props}
                data-brand={brand}
                autoComplete="cc-number"
                type="tel"
                pattern="[0-9０-９]*"
                inputMode={skipAutoFormatting ? "search" : "numeric"}
                guide={false}
                keepCharPositions={false}
                mask={mask}
                placeholderChar={"\u2000"}
                placeholder={placeholder || null}
                onChange={this.handleChange}
                onInputCapture={skipAutoFormatting ? disableFormattingOnCapture : undefined}
                value={skipAutoFormatting ? String(value) : fullWidthToHalfWidth(String(value))}
            />
        );
    }
}
